import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { useEffect } from 'react';
import { getRelationsAction } from 'src/redux/actions/dataActions';
import FormSingleSelect, { SelectItem } from 'src/components/Control/FormControls/FormSingleSelect';
import { FORM_ID } from 'src/models/FormModel';

interface Props {
  disabled?: boolean,
  form: FORM_ID,
  id?: string,
  name: string,
  label: string,
  onChange: (id:number) => void,
  value?: number | '',
}

const ContactRelationSelector = (props: Props) => {
  const dispatch = useAppDispatch();

  const {
    disabled, form, id, name, onChange, value, label,
  } = props;

  const relations = useSelector((state: Store) => state.data.relations);
  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  useEffect(() => {
    dispatch(getRelationsAction());
  }, []);

  const getItems = () => {
    const items:SelectItem[] = [
      { id: 0, text: 'none' },
    ];
    if (!relations.length) {
      return items;
    }
    relations.sort(
      (a, b) => a[`name_${lang}`].localeCompare(b[`name_${lang}`]),
    ).map((item: any) => {
      items.push({
        id: item.id,
        text: item[`name_${lang}`],
      } as SelectItem);
      return items;
    });
    return items;
  };

  return (
    <FormSingleSelect
      disabled={disabled}
      form={form}
      id={id}
      items={getItems()}
      label={label}
      name={name}
      onChange={(relId:number) => onChange(relId ?? 0)}
      value={value || ''}
      noMarginTop />
  );
};

export default ContactRelationSelector;
